/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Invoice_After_ShipmentInputs */

const en_reference_field_invoice_after_shipment = /** @type {(inputs: Reference_Field_Invoice_After_ShipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice after shipment`)
};

/**
* | output |
* | --- |
* | "Invoice after shipment" |
*
* @param {Reference_Field_Invoice_After_ShipmentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_invoice_after_shipment = /** @type {((inputs?: Reference_Field_Invoice_After_ShipmentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Invoice_After_ShipmentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_invoice_after_shipment(inputs)
});